import * as actions from "store/actions/transfer/edit";
import IUser from "Types/Transfer";
import dayjs from "dayjs";

export interface TransferEditState extends IUser {
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: TransferEditState = {
	loading: false,
	value: "",
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_TRANSFER: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_TRANSFER_SUCCESS: {
			return {
				...initialState,
				...payload,
				item: payload
			};
		}
		case actions.GET_TRANSFER_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.EDIT_TRANSFER: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.EDIT_TRANSFER_SUCCESS: {
			return {
				...initialState,
				item: payload
			};
		}
		case actions.EDIT_TRANSFER_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
